import React, { useState } from "react";
import { RCCButton, RCCIcon, RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import DefaultBody from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultBody";
import DefaultContainer from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultContainer";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import { GroupersOKR } from "src/pages/StrategicPlanning/Okr/interface";
import HeaderDashboard from "../../../DefaultDashboardComponents/HeaderDashboard";
import { ICardConfigs } from "../../../interface";
import { IDashboardOKRsData } from "../interface";
import Li from "./li";
import * as Styles from "./styles";

const DashboardListClassificationOKRs: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate } = useTranslation();
	const [dataOKRs, setDataOKRs] = useState<IDashboardOKRsData[]>([{
		notOnTarget: 0,
		onTarget: 0,
		total: 0,
		withoutValue: 0,
		group: 1
	},{
		notOnTarget: 0,
		onTarget: 0,
		total: 0,
		withoutValue: 0,
		group: 2
	},{
		notOnTarget: 0,
		onTarget: 0,
		total: 0,
		withoutValue: 0,
		group: 3
	}] as IDashboardOKRsData[]);

	const { loading } = useEffectFetchData<IDashboardOKRsData[]> (
		"DashboardOKRs/List", 
		{ group: true },
		({ data }) => {
			if(data && data.length > 0)
				setDataOKRs(data);
		}
	);

	return (
		<DefaultContainer>
			<HeaderDashboard 
				description={card?.daa002Descricao}
				title={card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : translate("Resumo de OKRs por Nível")}
				hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
				isLoading={loading}
			>
				<Link to={`/okr/panel/?group=${GroupersOKR.LEVEL}`} >
					<RCCTooltip
						text={translate("Painel de OKR")}
						color="grey"
					>
						<RCCButton
							color="transparent"
						>
							<AppIcons 
								name="strategicPlanning"
								size={14}
							/>
						</RCCButton>
					</RCCTooltip>
				</Link>
			</HeaderDashboard>


			<DefaultBody>
				{dataOKRs.length > 0 && (
					<>
						<Styles.LiTitles>
							<div />
							<div><RCCTooltip text={translate("Total")} color="purple" >{translate("Total")} </RCCTooltip></div>
							<div><RCCTooltip text={translate("Sem checkin")} color="blue" >{translate("Sem checkin")} </RCCTooltip></div>
							<div><RCCTooltip text={translate("Checkin parcial")} color="yellow" >{translate("Checkin parcial")} </RCCTooltip></div>
							<div><RCCTooltip text={translate("Atrasado")} color="red" >{translate("Atrasado")} </RCCTooltip></div>
							<div><RCCTooltip text={translate("Atingiu a meta")} color="green" >{translate("Atingiu a meta")} </RCCTooltip></div>
						</Styles.LiTitles>

						<Styles.LiPanelBodyContent style={{marginTop: "-0.75rem"}}>
							<div>
								<Title color="purple" size="sm">
									{translate("Organizacional")} 
								</Title>
								<Title color="purple" size="xs">
									<RCCIcon 
										color="var(--purple-light)"
										name="hierarchy"
										style={{ margin: "0 0.5rem"}}
									/>
									{translate("Objetivos")}
								</Title>
							</div>
							<Li data={dataOKRs.find((x) => x.group === 1)} showLink level="1" />
						</Styles.LiPanelBodyContent>

						<Styles.LiPanelBodyContent>
							<div>
								<Title color="purple" size="xs">
									<RCCIcon 
										color="var(--purple-light)"
										name="key"
										style={{ margin: "0 0.5rem"}}
									/>
									{translate("Resultados chave")} 
								</Title>
							</div>
							<Li data={dataOKRs.find((x) => x.group === 1)?.keyResults} />
						</Styles.LiPanelBodyContent>

						<Styles.LiPanelBodyContent>
							<div>
								<Title color="purple" size="sm">
									{translate("Equipe")} 
								</Title>
								<Title color="purple" size="xs">
									<RCCIcon 
										color="var(--purple-light)"
										name="hierarchy"
										style={{ margin: "0 0.5rem"}}
									/>
									{translate("Objetivos")}
								</Title>
							</div>
							<Li data={dataOKRs.find((x) => x.group === 2)} showLink level="2" />
						</Styles.LiPanelBodyContent>

						<Styles.LiPanelBodyContent>
							<div>
								<Title color="purple" size="xs">
									<RCCIcon 
										color="var(--purple-light)"
										name="key"
										style={{ margin: "0 0.5rem"}}
									/>
									{translate("Resultados chave")} 
								</Title>
							</div>
							<Li data={dataOKRs.find((x) => x.group === 2)?.keyResults} />
						</Styles.LiPanelBodyContent>

						<Styles.LiPanelBodyContent>
							<div>
								<Title color="purple" size="sm">
									{translate("Individual")} 
								</Title>
								<Title color="purple" size="xs">
									<RCCIcon 
										color="var(--purple-light)"
										name="hierarchy"
										style={{ margin: "0 0.5rem"}}
									/>
									{translate("Objetivos")}
								</Title>
							</div>
							<Li data={dataOKRs.find((x) => x.group === 3)} showLink level="3" />
						</Styles.LiPanelBodyContent>

						<Styles.LiPanelBodyContent>
							<div>
								<Title color="purple" size="xs">
									<RCCIcon 
										color="var(--purple-light)"
										name="key"
										style={{ margin: "0 0.5rem"}}
									/>
									{translate("Resultados chave")} 
								</Title>
							</div>
							<Li data={dataOKRs.find((x) => x.group === 3)?.keyResults} />
						</Styles.LiPanelBodyContent>
					</>
				)}
			</DefaultBody>
		</DefaultContainer>
	);
};

export default DashboardListClassificationOKRs;
